module.exports = "img/videos/24.6cc592.mp4";